let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("jPS1u"), load("hRE4a")]).then(() => parcelRequire('d4y8J'));